import React, { FC, ReactNode } from 'react';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import { ToastContainer } from 'react-toastify';
import { persistor, Store } from '../../store';
import AppContextProvider from './AppContextProvider';
import i18n from '../../i18n';
import ZoomContextProvider from './ZoomContext';
import SearchContextProvider from './SearchContextProvider';
import AppMobileContextProvider from './AppMobileCommunicationContext';

interface ApplicationProvidersProps {
    children: ReactNode;
}

const ApplicationProviders: FC<ApplicationProvidersProps> = ({ children }) => {
    return (
        <I18nextProvider i18n={i18n}>
            <ToastContainer autoClose={8000} position="top-center" />
            <Provider store={Store}>
                <PersistGate loading={null} persistor={persistor}>
                        <AppContextProvider>
                            <AppMobileContextProvider>
                                <SearchContextProvider>
                                    <ZoomContextProvider>{children}</ZoomContextProvider>
                                </SearchContextProvider>
                            </AppMobileContextProvider>
                        </AppContextProvider>
                </PersistGate>
            </Provider>
        </I18nextProvider>
    );
};

export default ApplicationProviders;
